var map = {
	"./3.png": "LHqX",
	"./arrow2.png": "mzkm",
	"./attack_arrow.png": "Oi1Q",
	"./attack_direction.png": "yC2W",
	"./attack_direction_dark.png": "dZRU",
	"./attack_english.png": "ZJ7m",
	"./attack_english_dark.png": "omVJ",
	"./attack_spanish.png": "i6HW",
	"./attack_spanish_dark.png": "OxzC",
	"./backgroundWhite.png": "Q3Wx",
	"./black_body.png": "FSUB",
	"./black_x.png": "bn3I",
	"./bodyparts/1/orange.png": "ppPf",
	"./bodyparts/1/red.png": "dCuh",
	"./bodyparts/1/yellow.png": "1zfF",
	"./bodyparts/10/orange.png": "zMms",
	"./bodyparts/10/red.png": "9BWd",
	"./bodyparts/10/yellow.png": "2Qk3",
	"./bodyparts/11/orange.png": "/zvB",
	"./bodyparts/11/red.png": "i1s+",
	"./bodyparts/11/yellow.png": "E4O3",
	"./bodyparts/12/orange.png": "g0B0",
	"./bodyparts/12/red.png": "3rKC",
	"./bodyparts/12/yellow.png": "zPBp",
	"./bodyparts/13/orange.png": "GqZ1",
	"./bodyparts/13/red.png": "fB/c",
	"./bodyparts/13/yellow.png": "oQ8X",
	"./bodyparts/14/orange.png": "uaKF",
	"./bodyparts/14/red.png": "n1ac",
	"./bodyparts/14/yellow.png": "oGn4",
	"./bodyparts/2/orange.png": "8ubk",
	"./bodyparts/2/red.png": "uhYp",
	"./bodyparts/2/yellow.png": "FhqU",
	"./bodyparts/3/orange.png": "OMfe",
	"./bodyparts/3/red.png": "yK4A",
	"./bodyparts/3/yellow.png": "6Cen",
	"./bodyparts/4/orange.png": "JZLI",
	"./bodyparts/4/red.png": "rY7b",
	"./bodyparts/4/yellow.png": "wRSX",
	"./bodyparts/5/orange.png": "w4/g",
	"./bodyparts/5/red.png": "PfCe",
	"./bodyparts/5/yellow.png": "7spm",
	"./bodyparts/6/orange.png": "BggY",
	"./bodyparts/6/red.png": "JRco",
	"./bodyparts/6/yellow.png": "HRQZ",
	"./bodyparts/7/orange.png": "UU9E",
	"./bodyparts/7/red.png": "ZMHV",
	"./bodyparts/7/yellow.png": "btkO",
	"./bodyparts/8/orange.png": "Efu8",
	"./bodyparts/8/red.png": "CWAA",
	"./bodyparts/8/yellow.png": "f27p",
	"./bodyparts/9/orange.png": "qJS8",
	"./bodyparts/9/red.png": "hS4m",
	"./bodyparts/9/yellow.png": "gxiG",
	"./bubble-size.png": "tf0z",
	"./cbf-logo.png": "cmeq",
	"./contactPageES.png": "74nO",
	"./cover.png": "qEfr",
	"./dl.png": "vk+v",
	"./driblab.png": "Fm44",
	"./driblab_color.png": "EiMx",
	"./driblab_color_white.png": "MWoR",
	"./driblab_dark.png": "53V8",
	"./driblab_fpbd.png": "HLOm",
	"./driblab_normal_color.png": "l6k4",
	"./driblab_normal_white.png": "ZwhF",
	"./driblab_white.png": "y+CX",
	"./driblab_white_box_pro.png": "+u1U",
	"./eng-fa-logo.png": "RRyZ",
	"./favicon.png": "06CR",
	"./fb.png": "Y3Bk",
	"./front_goal.png": "9uGq",
	"./half_pitch_black.png": "NtN7",
	"./half_pitch_blue.png": "vQdk",
	"./half_pitch_green.png": "EdVJ",
	"./half_pitch_grey.png": "0LPn",
	"./half_pitch_white.png": "8+0S",
	"./insta.png": "ZLNX",
	"./legend.png": "OodW",
	"./legend_dark.png": "HQJU",
	"./legend_english.png": "brKA",
	"./legend_english_dark.png": "wWt0",
	"./legend_spanish.png": "vqDR",
	"./legend_spanish_dark.png": "2K20",
	"./legend_xa.png": "TqRZ",
	"./legend_xa_dark.png": "i0OK",
	"./legend_xa_dark_vertical.png": "oxTJ",
	"./legend_xa_english.png": "K1wN",
	"./legend_xa_english_dark.png": "dxDs",
	"./legend_xa_english_dark_vertical.png": "PoPW",
	"./legend_xa_english_vertical.png": "67TI",
	"./legend_xa_spanish.png": "4mpf",
	"./legend_xa_spanish_dark.png": "+Q/V",
	"./legend_xa_spanish_dark_vertical.png": "UJzI",
	"./legend_xa_spanish_vertical.png": "wdY6",
	"./legend_xa_vertical.png": "4Dgi",
	"./legend_xg.png": "9yJL",
	"./legend_xg_dark.png": "zxGK",
	"./legend_xg_dark_vertical.png": "Uen6",
	"./legend_xg_english.png": "Hec4",
	"./legend_xg_english_dark.png": "zRyM",
	"./legend_xg_english_dark_vertical.png": "cKRc",
	"./legend_xg_english_vertical.png": "6yIz",
	"./legend_xg_spanish.png": "CHjW",
	"./legend_xg_spanish_dark.png": "FOr9",
	"./legend_xg_spanish_dark_vertical.png": "gOS5",
	"./legend_xg_spanish_vertical.png": "bTCJ",
	"./legend_xg_vertical.png": "AzRh",
	"./logo_powered.png": "i4UL",
	"./logo_powered_horizontal.png": "I7uR",
	"./pitch_black.png": "RrAv",
	"./pitch_black_HQ.png": "qoTF",
	"./pitch_black_old.png": "o2/A",
	"./pitch_black_wide.png": "HSxZ",
	"./pitch_blue.png": "FInX",
	"./pitch_blue_HQ.png": "xxDF",
	"./pitch_blue_old.png": "yvzL",
	"./pitch_blue_vertical.png": "KXn4",
	"./pitch_blue_wide.png": "C2pq",
	"./pitch_green.png": "t70D",
	"./pitch_green_HQ.png": "nQsG",
	"./pitch_green_old.png": "Sqbw",
	"./pitch_green_vertical.png": "Pjac",
	"./pitch_green_wide.png": "HZhf",
	"./pitch_grey.png": "d54U",
	"./pitch_grey_wide.png": "xBif",
	"./pitch_white.png": "lp7q",
	"./pitch_white_old.png": "Kn8P",
	"./pitch_white_wide.png": "mYbJ",
	"./slides/1.png": "fnIc",
	"./slides/2.png": "gya7",
	"./slides/3.png": "+mq+",
	"./slides/4.png": "VeOp",
	"./slides/5.png": "bxyG",
	"./squad_template_black.png": "nbA2",
	"./squad_template_blue.png": "PbqE",
	"./squad_template_green.png": "emU/",
	"./squad_template_grey.png": "fGuK",
	"./squad_template_white.png": "EdnS",
	"./t3n-logo.png": "q568",
	"./twitter.png": "ZKaF",
	"./visualization_lollipop.png": "XtG1",
	"./visualization_polar.png": "AQUM",
	"./visualization_radar.png": "pO6P"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zfj7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.png$
// module id = zfj7
// module chunks = 94